import { stringifyQs } from '@shared/utils/urls';

export const loginPath = '/login/';
export const loginUrl = loginPath;

export const signupPath = '/signup/';
export const signupUrl = signupPath;

export const forgotPasswordPath = '/forgot-password/';
export const forgotPasswordUrl = forgotPasswordPath;

export const resetPasswordPath = '/reset-password/:token';
export const resetPasswordWithOrgPath = '/reset-password/:organizationId/:token';
export const resetPasswordUrl = resetPasswordPath;

export const resetPasswordSuccessPath = '/reset-password/success/';
export const resetPasswordSuccessUrl = resetPasswordSuccessPath;

export const acceptInvitationPath = '/accept-invitation';
export interface AcceptInvitationUrlQueryParams {
  token: string;
}
export const acceptInvitationUrl = (params?: AcceptInvitationUrlQueryParams) =>
  params ? `${acceptInvitationPath}?${stringifyQs(params)}` : acceptInvitationPath;

export const emailVerificationPath = '/verify-email/:token';
export const emailVerificationSuccessPath = '/email-verification-success/';
export const emailVerificationSuccessUrl = emailVerificationSuccessPath;

export const newPasswordPath = '/new-password/';

export const requestMagicLinkPath = '/request-magic-link/';

export const verifyMagicLinkPath = '/verify-magic-link/:token';

export const authMagicLinkPath = '/auth/magic-link';

export const loginCallbackPath = '/login/callback/';
export const signupCallbackPath = '/signup/callback/';

export interface NewPasswordUrlQueryParams {
  email: string;
  token: string;
}
export const newPasswordUrl = (params?: NewPasswordUrlQueryParams) =>
  newPasswordPath + '?' + stringifyQs(params);

export interface LoginOpenidconnectUrlQueryParams {
  code: string;
  state: string;
}
export type LoginUrlQueryParams = LoginOpenidconnectUrlQueryParams;

export interface EmailVerificationQueryParams {
  token: string;
}

export const emailVerificationUrl = (params?: EmailVerificationQueryParams) =>
  `${emailVerificationPath}?${stringifyQs(params)}`;
